const LUKKEY_DEBUG_STORAGE_KEY = "lukkey_debug";

export const isLukkeyDebugEnabled = () => {
  if (typeof window === "undefined") return false;

  const searchParams = new URLSearchParams(window.location?.search || "");
  if (searchParams.get("lukkeyDebug") === "1") return true;
  if (searchParams.get("debugLukkey") === "1") return true;

  try {
    return window.localStorage?.getItem(LUKKEY_DEBUG_STORAGE_KEY) === "1";
  } catch {
    return false;
  }
};

export const logLukkeyDebug = (scope, message, payload) => {
  if (!isLukkeyDebugEnabled()) return;

  const prefix = `[LUKKEY_DEBUG][${scope}] ${message}`;
  if (typeof payload === "undefined") {
    console.debug(prefix);
    return;
  }
  console.debug(prefix, payload);
};
